import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("driving/index"),
  
  store: (userData) => clientAuth.post('driving/store', { json: userData }),
  

  show:(id)=>clientAuth.get('driving/show/'+id),

  update:(id,userData)=>clientAuth.post('driving/update/'+id,{json:userData}),

  destroy:(id)=>clientAuth.delete(`driving/destroy/${id}`),
};